
import { defineComponent, PropType } from '@vue/composition-api';
import { MyBetResult } from '../../../../../types/sport';

export default defineComponent({
  name: 'BetStatusIcon',
  props: {
    status: {
      type: String as PropType<MyBetResult>,
      required: true
    },
    halfWon: {
      type: Boolean,
      default: false
    },
    halfLost: {
      type: Boolean,
      default: false
    },
    size: {
      type: String as PropType<'sm' | 'md' | 'lg'>,
      default: 'md'
    }
  },
  methods: {
    t(key: string): string {
      return this.$t(key) as string;
    }
  }
});
